"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import LocationsList from "./LocationsList";
import { usePathname } from "next/navigation";

export default function Header({ siteConfig, locations }) {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const pathname = usePathname();


  const menuRef = useRef(null);



  // console.log('pathname', pathname);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };
  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);
  const toggleSubMenu = (id) => {
    setOpenSubMenu(openSubMenu === id ? null : id);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        toggleMenu();
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, toggleMenu]);

  
  const menu = [
    {
      id: 1,
      title: "Home",
      url: "/",
      subMenu: null,
    },
    {
      id: 2,
      title: "About us",
      url: "/about-us",
      subMenu: [
        { id: 21, title: "Who we are", url: "/about-us/who-we-are" },
        { id: 22, title: "Why POOP 911?", url: "/about-us/why-poop-911" },
        {
          id: 23,
          title: "POOP 911 Community",
          url: "/about-us/poop-911-community",
        },
        {
          id: 24,
          title: "What's the Scoop?",
          url: "/whats-the-scoop-podcast",
        },
      ],
    },
    {
      id: 3,
      title: "Services",
      url: "/services-rates/",
      subMenu: [
        { id: 31, title: "Residential Services", url: "/services-rates/residential-pooper-scooper-service/" },
        { id: 32, title: "Commercial Services", url: "/services-rates/commercial-pooper-scooper-service/" },
        {
          id: 33,
          title: "Yard Deodorizing",
          url: "/services-rates/yard-deodorizing",
        },
        {
          id: 34,
          title: "Special Event Services",
          url: "/services-rates/community-park-special-event-services",
        },
        {
          id: 35,
          title: "Additional Services",
          url: "/services-rates/additional-services",
        },
        {
          id: 36,
          title: "List of Service Areas",
          url: "/service-area",
        },
      ],
    },
    {
      id: 4,
      title: "Reviews",
      url: "/customer-reviews",
      subMenu: null,
    },
    {
      id: 5,
      title: "Facts",
      url: "/dog-waste-facts",
      subMenu: null,
    },
    {
      id: 6,
      title: "FAQ",
      url: "/faq",
      subMenu: null,
    },
    {
      id: 7,
      title: "Blog",
      url: "/pooper-scooper",
      subMenu: null,
    },
    {
      id: 8,
      title: "Franchise",
      url: "/become-a-franchisee",
      subMenu: [
        {
          id: 81,
          title: "Why Franchise",
          url: "/become-a-franchisee/why-franchise",
        },
        {
          id: 83,
          title: "Join POOP 911",
          url: "/become-a-franchisee/convert-your-business",
        },
      ],
    },
    {
      id: 9,
      title: "Careers",
      url: "/career-opportunities",
      subMenu: null,
    },
  ];

  return (
    <>
      <header
        className={`sticky  top-0 z-[99999] transition-colors duration-300 ${
          isSticky ? "bg-brandLight" : "bg-white"
        }`}
      >
        <div className="container  flex justify-between items-center py-4">
          <div data-logo={siteConfig.logo.url}>
            <Link href="/">
              <img
                src={siteConfig.logo.url}
                alt="Logo"
                width="250"
                height="70"
              />
            </Link>
          </div>
          <button
            id="mobile-toggle"
            className="lg:hidden menu-toggle-open"
            aria-label="Open menu"
            onClick={toggleMenu}
          >
            <span className="menu-toggle-icon">
              <svg
                fill="currentColor"
                xmlns="https://www..w3.org/2000/svg"
                width="24"
                height="28"
                viewBox="0 0 24 28"
              >
                <span>Toggle Menu</span>
                <path d="M24 21v2c0 0.547-0.453 1-1 1h-22c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547 0 1 0.453 1 1zM24 13v2c0 0.547-0.453 1-1 1h-22c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547 0 1 0.453 1 1zM24 5v2c0 0.547-0.453 1-1 1h-22c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h22c0.547 0 1 0.453 1 1z"></path>
              </svg>
            </span>
          </button>
          <div className="hidden lg:flex items-center space-x-4 relative z-50">
            <a
              href={`tel:${siteConfig.phone}`}
              className="text-brandGray flex items-center space-x-1"
            >
              <span>{siteConfig.phone}</span>
            </a>
            <a
              href="https://myaccount.poop911.com/login"
              className="flex text-brandGray uppercase font-semibold space-x-2 items-center"
            >
               <svg aria-hidden="true" className="" fill="currentColor" version="1.1" xmlns="https://www..w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><span>Account</span><path d="M21 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-8c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h8c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM17 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM15 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121z"></path>
               </svg>  
              <span>Portal</span>
            </a>
            <a
              href="https://signup.poop911.com/signup/step1"
              target="_blank"
               rel="noopener noreferrer"
              className="flex hover:bg-brandGreen font-jost space-x-2 hover:shadow-sm transition-all items-center py-2.5 px-6 lg:px-8 text-white rounded-full uppercase bg-brand"
            >
              <span>Schedule Service</span>
            </a>
          </div>
        </div>
      </header>

      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-[9999999] transition-transform transform ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } lg:hidden`}
        
      >
        <div ref={menuRef}  className="bg-black text-white h-full w-4/5 p-4 absolute right-0 ">
        <div className="flex justify-end">
          <button
            className="text-white hover:text-gray-200 mb-4 ml-auto"
            onClick={toggleMenu}
          >
            <svg
  xmlns="https://www..w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="w-6 h-6"
>
  <line x1="18" y1="6" x2="6" y2="18"></line>
  <line x1="6" y1="6" x2="18" y2="18"></line>
</svg>

          </button>
          </div>
          <ul className="divide-y  divide-gray-700">
            {menu.map((item) => (
              <li key={item.id} className="relative z-[999] px-3 py-3 ">
                <div
                  className="flex justify-between items-center text-gray-800  cursor-pointer"
                  onClick={() => item.subMenu && toggleSubMenu(item.id)}
                >
                  <Link
                    href={item.url}
                    className={`block  text-xl  uppercase font-semibold  ${
                    pathname === item.url ? " text-brand" : "hover:text-brand text-gray-100"
                  }`}
                    onClick={item.subMenu ? null : toggleMenu}
                  >
                    {item.title}
                  </Link>
                  {item.subMenu && (
                    <svg
                      className={`transform text-white ${
                        openSubMenu === item.id ? "rotate-180" : "rotate-0"
                      } transition-transform`}
                      fill="currentColor"
                      xmlns="https://www..w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 16.5l6-6h-12z"></path>
                    </svg>
                  )}
                </div>
                {item.subMenu && openSubMenu === item.id && (
                  <ul className="mt-2 ml-4 divide-y divide-gray-600">
                    {item.subMenu.map((subItem) => (
                      <li key={subItem.id} className="py-3">
                          {/* className="block text-gray-200 uppercase text-xl py-1" */}
                        <Link
                          href={subItem.url}
                          onClick={toggleMenu}
                          className={`block  font-semibold uppercase text-xl py-1 ${
                            pathname === subItem.url ? "text-brandGreen " : "hover:bg-black text-gray-100"
                          }`} 
                        >
                          {subItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            <li className="relative z-[999] px-3 py-3 ">
            <a
              href="https://myaccount.poop911.com/login"
              className="flex text-gray-200 uppercase font-semibold space-x-2 items-center"
            >
               <svg aria-hidden="true" className="" fill="currentColor" version="1.1" xmlns="https://www..w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><span>Account</span><path d="M21 21v-2c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464h-8c-1.38 0-2.632 0.561-3.536 1.464s-1.464 2.156-1.464 3.536v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-2c0-0.829 0.335-1.577 0.879-2.121s1.292-0.879 2.121-0.879h8c0.829 0 1.577 0.335 2.121 0.879s0.879 1.292 0.879 2.121v2c0 0.552 0.448 1 1 1s1-0.448 1-1zM17 7c0-1.38-0.561-2.632-1.464-3.536s-2.156-1.464-3.536-1.464-2.632 0.561-3.536 1.464-1.464 2.156-1.464 3.536 0.561 2.632 1.464 3.536 2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536zM15 7c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121 0.335-1.577 0.879-2.121 1.292-0.879 2.121-0.879 1.577 0.335 2.121 0.879 0.879 1.292 0.879 2.121z"></path>
               </svg>  
              <span>Portal</span>
            </a>
            </li>
            <li className="relative px-3 py-3 ">
            <LocationsList locations={locations} toggleMenu={toggleMenu}/>

            </li>
            <li className="relative px-3 py-3 ">
            <a
            href="https://signup.poop911.com/signup/step1"
            className="mx-auto mt-5 inline-block hover:bg-brandGreen font-jost  space-x-2 hover:shadow-sm transition-all items-center py-2.5 px-6 lg:px-8 text-white rounded-full uppercase bg-brand"
          >
            Schedule a Service
          </a>
            </li>
          </ul>
        </div>
      </div>

      <nav className="hidden lg:block bg-brandLight">
        <div className="container mx-auto">
          <div className="flex py-2  justify-between">
            <ul className="flex items-center justify-between flex-1">
              {menu.map((item) => (
                <li key={item.id} className="relative group z-[999]">
                  <Link
                    href={item.url}
                    className={`px-2 text-sm xl:px-3 border rounded-full uppercase font-semibold xl:text-base  py-2.5 flex ${
                    pathname === item.url ? " text-brand" : "hover:text-brand text-brandGray"
                  }`}
                  >
                    {/* className="hover:text-brand hover:border-brand px-2 text-sm xl:px-3 transition border border-brandLight rounded-full uppercase font-semibold xl:text-base text-brandGray py-2.5 flex" */}
                    {item.title}
                    {item.subMenu && (
                      <svg
                        className="ml-2"
                        fill="currentColor"
                        xmlns="https://www..w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 16.5l6-6h-12z"></path>
                      </svg>
                    )}
                  </Link>
                  {item.subMenu && (
                    <ul className="absolute left-0 top-full hidden group-hover:block bg-[#262827] shadow-lg w-full z-50 min-w-64">
                      {item.subMenu.map((subItem) => (
                        <li key={subItem.id}>
                            {/* className="block px-4 py-4 text-sm font-semibold hover:bg-black uppercase text-gray-100" */}
                          <Link
                            href={subItem.url}
                            className={`block px-4 py-4 text-sm font-semibold uppercase  ${
                            pathname === subItem.url ? "text-brandGreen " : "hover:bg-black text-gray-100"
                          }`}
                          >

                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
              <li>
                
              </li>
            </ul>
            <div className="flex">
            <div className="w-px h-full border-l border-brandGray bg-green-300 min-h-12 mx-4"></div>
            <LocationsList locations={locations} />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
